import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-mdb-select',
  templateUrl: './mdb-select.component.html',
  styleUrls: ['./mdb-select.component.scss']
})
export class MdbSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  selectedValue = new UntypedFormControl('4');
  options = [
    { value: '1', label: 'One' },
    { value: '2', label: 'Two' },
    { value: '3', label: 'Three' },
    { value: '4', label: 'Four' },
    { value: '5', label: 'Five' },
    { value: '6', label: 'Six' },
    { value: '7', label: 'Seven' },
    { value: '8', label: 'Eigth' },
  ];

}
